<div class="title">
  <mat-icon>traffic</mat-icon>
  Status
</div>
<div class="description">SELECT THE STATUSES TO FILTER BY</div>

<div class="options">
  <!-- Using custom status chip design : -->
  <framework-work-status-chip
    *ngFor="let status of allStatuses"
    [ngClass]="{'selected': isSelected(status)}"
    [workStatus]="status"
    (click)="isSelected(status) ? removeProduct(status) : addProduct(status)"
  >
  </framework-work-status-chip>
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
